var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3393 11.0625C2.59384 9.80582 2.33277 8.32024 2.60512 6.88471C2.87747 5.44918 3.6645 4.16245 4.81843 3.26614C5.97235 2.36983 7.41379 1.92559 8.87208 2.01684C10.3304 2.1081 11.7052 2.72857 12.7384 3.76175C13.7715 4.79492 14.392 6.16973 14.4833 7.62802C14.5745 9.0863 14.1303 10.5277 13.234 11.6817C12.3377 12.8356 11.051 13.6226 9.61543 13.895C8.17991 14.1674 6.69433 13.9063 5.43766 13.1608L5.43767 13.1608L3.36539 13.7529C3.27965 13.7774 3.18892 13.7785 3.1026 13.7561C3.01629 13.7337 2.93752 13.6887 2.87447 13.6256C2.81142 13.5626 2.76637 13.4838 2.74401 13.3975C2.72164 13.3112 2.72276 13.2205 2.74726 13.1347L3.33934 11.0624L3.3393 11.0625Z",
    stroke: "#DC7835",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7H10.5",
    stroke: "#DC7835",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9H10.5",
    stroke: "#DC7835",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.7a5e9f878c06f505450cfef2b59a8142.svg";
export { ForwardRef as ReactComponent };